export const LOAD_TASKS = 'tasks/LOAD_TASKS';
export const LOAD_TASKS_SUCCESS = 'tasks/LOAD_TASKS_SUCCESS';
export const LOAD_TASKS_ERROR = 'tasks/LOAD_TASKS_ERROR';
export const LOAD_SUMMARY = 'tasks/LOAD_SUMMARY';
export const LOAD_SUMMARY_SUCCESS = 'tasks/LOAD_SUMMARY_SUCCESS';
